import React, { FC } from 'react';
import styled, { StyledComponentProps } from 'styled-components';

import { typographyStyles, TypographyStylesProps } from './typographyStyles';

const subheadings = {
  1: {
    fontSize: '28px',
    lineHeight: '40px',
  },
  2: {
    fontSize: '24px',
    lineHeight: '40px',
  },
};

interface InternalSubheadingProps {
  variant: keyof typeof subheadings;
  medium?: boolean;
}

export interface SubheadingProps
  extends StyledComponentProps<
    'div',
    Record<string, any>,
    TypographyStylesProps & InternalSubheadingProps,
    never
  > {}

export const SubheadingText = styled.div<InternalSubheadingProps>`
  font-family: 'Manrope';
  font-weight: ${({ medium }) => (medium ? '500' : '400')};
  font-size: ${({ variant }) => subheadings[variant].fontSize};
  line-height: ${({ variant }) => subheadings[variant].lineHeight};
  ${typographyStyles}
`;

export const Subheading: FC<SubheadingProps> = ({
  variant,
  medium = false,
  ...rest
}) => <SubheadingText variant={variant} medium={medium} {...rest} />;
